import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialogRoot: {
    '@media(max-width: 560px)': {
      padding: '0px !important'
    }
  },
  dialogPaper: {
    width: '100%',
    maxWidth: 800,
    backgroundColor: theme.colors.modal__background_primary,
    borderRadius: theme.sizes.roundCorners,
    boxShadow: '0 2px 2px 0 #0000003d, 0 0 2px 0 #0000001e',
    flexDirection: 'column',
    overflowY: 'auto',
    minHeight: 560
  },
  dialogTitle: {
    fontSize: 42,
    fontWeight: 300,
    color: theme.colorPalette.green_75,
    '@media(max-width: 560px)': {
      fontSize: 24,
      fontWeight: 300
    },
    padding: theme.spacing(0, 4)
  },
  dialogContent: {
    padding: theme.spacing(4, 10)
  },
  dialogActions: {
    padding: theme.spacing(3, 10, 10, 10),
    justifyContent: 'flex-end'
  },
  dialogCloseButton: {
    boxSizing: 'content-box',
    height: 48,
    width: 48,
    padding: 0,
    margin: '8px 10px 0'
  },
  dialogCloseButtonIcon: {
    height: 48,
    width: 48
  },
  backdrop: {
    backgroundColor: `${theme.colorPalette.green_90}d9` // 'd9' is the alpha value
  },
  scrollPaper: {
    alignItems: 'flex-start'
  }
}));

export default useStyles;
